import { render, staticRenderFns } from "./VendorList_List.vue?vue&type=template&id=e7cd6518&"
import script from "./VendorList_List.vue?vue&type=script&lang=js&"
export * from "./VendorList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports